import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Flag = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Flag };